import { getUserAgent } from '@/utils/user-agent'
import { axios, handleResponse } from '@/api/axios.js'
import appConfig from '@/config'
import Cookie from 'js-cookie'
import QS from 'qs'
function _normoalize(options, opts) {
  let method = options.method.toUpperCase()
  let token = Cookie.get(appConfig.cookie.TOKEN)
  let submitToken = Cookie.get(appConfig.cookie.SUBMIT_TOKEN)
  let request
  // 携带token
  if (token) {
    if (!options.headers) options.headers = {}
    options.headers[appConfig.headers.TOKEN] = token
  }
  if (submitToken) {
    if (!options.headers) options.headers = {}
    options.headers[appConfig.cookie.SUBMIT_TOKEN] = submitToken
  }
  // 携带UA
  let userAgent = getUserAgent()
  if (userAgent) {
    if (!options.headers) options.headers = {}
    options.headers[appConfig.headers.USER_AGENT] = encodeURIComponent(
      userAgent
    )
  }
  switch (method) {
    case 'GET':
      request = async () => {
        if (options.params) {
          // Object.keys(options.params).forEach(k => {
          //   options.params[k] = encodeURIComponent(options.params[k])
          // })
        }
        return handleResponse(
          await axios.get(options.path, {
            headers: options.headers,
            params: options.params,
            timeout: appConfig.timeout,
            ...opts
          })
        )
      }
      break
    case 'POST':
      request = async () => {
        return handleResponse(
          await axios.post(options.path, options.params, {
            headers: options.headers,
            timeout: appConfig.timeout
          })
        )
      }
      break
    case 'PUT':
      request = async () => {
        return handleResponse(
          await axios.put(options.path, options.params, {
            headers: options.headers,
            timeout: appConfig.timeout
          })
        )
      }
      break
    case 'DELETE':
      request = async () => {
        return handleResponse(
          await axios.delete(options.path, {
            headers: options.headers,
            timeout: appConfig.timeout,
            params: options.params
          })
        )
      }
  }
  return request
}

const request = config => {
  return (name, params = null, headers = {}, opts = {}) => {
    // append: ''
    if (typeof name !== 'string') throw new Error('name参数必须为字符串')
    if (!name || !name.trim()) throw new Error('name不能为空')
    let names = name.split('/')
    let namespace = names[0]
    let nameParam = names[1]
    let api = config[namespace]
    for (let i = 0; i < api.length; ++i) {
      let item = api[i]
      if (item.name === nameParam) {
        let options = {
          headers: { ...headers }
        }
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            options[key] = item[key]
          }
        }
        item.path = item.path.replace('//', '/')
        options.path = item.mock ? item.mockPath : item.path
        // 动态路由最初版写法 比较麻烦
        if (item.append) options.path += '/' + opts.append
        options.params = !params ? item.params : params
        // 动态路由2.0写法
        if (
          options.path.indexOf('{') !== -1 &&
          options.path.indexOf('}') !== -1
        ) {
          let path = ''
          let _paths = options.path.split('/')
          let paths = _paths ? _paths.filter(ii => ii) : [] // 去空值
          for (let i = 0; i < paths.length; ++i) {
            let matcher = paths[i].match(/^\{(\w+)\}$/)
            if (!matcher) {
              // 非动态
              path = path + `/${paths[i]}`
            } else {
              path += `/${options.params[matcher[1]]}`
              delete options.params[matcher[1]]
            }
          }
          options.path = path
        }
        opts.paramsSerializer = function(params) {
          for (let i in params) {
            if (params[i] == null) {
              delete params[i]
            }
          }
          const info = QS.stringify(params, { arrayFormat: 'repeat' })
          return info
        }
        return _normoalize(options, opts)
      }
    }
    throw new Error(`没有找到相应的接口：${namespace} => ${nameParam}.`)
  }
}

export default request



// WEBPACK FOOTER //
// ./src/api/request.js